import React from 'react';

interface ShuttersProps extends React.SVGProps<SVGSVGElement> {
  patternUrl: string;
}

export const Shutters89mmClearViewMidRailFaceFit = ({
  patternUrl,
  ...props
}: ShuttersProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 555.2 410"
      preserveAspectRatio="none"
      {...props}
    >
      <defs>
        <pattern
          id="shutters89"
          patternUnits="userSpaceOnUse"
          width="100"
          height="100"
        >
          <image href={patternUrl} x="0" y="0" width="100" height="100" />
        </pattern>
      </defs>
      <defs>
        <linearGradient
          id="prefix__linear-gradient"
          x1={41.4}
          y1={-90.04}
          x2={41.4}
          y2={-60.16}
          gradientTransform="matrix(1 0 0 -1 .5 -19.5)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.24} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.3} />
        </linearGradient>
        <linearGradient
          id="prefix__linear-gradient-2"
          x1={5720.84}
          y1={-90.04}
          x2={5720.84}
          y2={-60.16}
          gradientTransform="rotate(180 2988.795 -9.75)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-3"
          x1={41.4}
          y1={-120.38}
          x2={41.4}
          y2={-90.51}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-4"
          x1={5720.84}
          y1={-120.38}
          x2={5720.84}
          y2={-90.51}
          gradientTransform="rotate(180 2988.795 -9.75)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-5"
          x1={41.4}
          y1={-150.61}
          x2={41.4}
          y2={-120.74}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-6"
          x1={5720.84}
          y1={-150.61}
          x2={5720.84}
          y2={-120.74}
          gradientTransform="rotate(180 2988.795 -9.75)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-7"
          x1={41.4}
          y1={-180.76}
          x2={41.4}
          y2={-150.89}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-8"
          x1={5720.84}
          y1={-180.76}
          x2={5720.84}
          y2={-150.89}
          gradientTransform="rotate(180 2988.795 -9.75)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-9"
          x1={41.4}
          y1={-211}
          x2={41.4}
          y2={-181.12}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-10"
          x1={5720.84}
          y1={-211}
          x2={5720.84}
          y2={-181.12}
          gradientTransform="rotate(180 2988.795 -9.75)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-11"
          x1={41.4}
          y1={-268.33}
          x2={41.4}
          y2={-238.46}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-12"
          x1={5720.84}
          y1={-268.33}
          x2={5720.84}
          y2={-238.46}
          gradientTransform="rotate(180 2988.795 -9.75)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-13"
          x1={41.4}
          y1={-298.58}
          x2={41.4}
          y2={-268.7}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-14"
          x1={5720.84}
          y1={-298.58}
          x2={5720.84}
          y2={-268.7}
          gradientTransform="rotate(180 2988.795 -9.75)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-15"
          x1={41.4}
          y1={-328.8}
          x2={41.4}
          y2={-298.93}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-16"
          x1={5720.84}
          y1={-328.8}
          x2={5720.84}
          y2={-298.93}
          gradientTransform="rotate(180 2988.795 -9.75)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-17"
          x1={41.4}
          y1={-359.06}
          x2={41.4}
          y2={-329.18}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-18"
          x1={5720.84}
          y1={-359.06}
          x2={5720.84}
          y2={-329.18}
          gradientTransform="rotate(180 2988.795 -9.75)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-19"
          x1={41.4}
          y1={-389.25}
          x2={41.4}
          y2={-359.38}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-20"
          x1={5720.84}
          y1={-389.25}
          x2={5720.84}
          y2={-359.38}
          gradientTransform="rotate(180 2988.795 -9.75)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-21"
          x1={405.42}
          y1={-78.25}
          x2={405.42}
          y2={-73.6}
          gradientTransform="matrix(1 0 0 -1 .5 -19.5)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.02} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.37} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.6} />
        </linearGradient>
        <linearGradient
          id="prefix__linear-gradient-22"
          x1={405.42}
          y1={-107.79}
          x2={405.42}
          y2={-103.14}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-23"
          x1={405.42}
          y1={-137.24}
          x2={405.42}
          y2={-132.59}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-24"
          x1={405.42}
          y1={-166.61}
          x2={405.42}
          y2={-161.95}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-25"
          x1={405.42}
          y1={-196.06}
          x2={405.42}
          y2={-191.41}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-26"
          x1={405.42}
          y1={-257.76}
          x2={405.42}
          y2={-253.12}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-27"
          x1={405.42}
          y1={-287.15}
          x2={405.42}
          y2={-282.51}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-28"
          x1={405.42}
          y1={-316.53}
          x2={405.42}
          y2={-311.89}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-29"
          x1={405.42}
          y1={-345.92}
          x2={405.42}
          y2={-341.28}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-30"
          x1={405.42}
          y1={-375.3}
          x2={405.42}
          y2={-370.66}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <pattern
          id="prefix__SVGID_1_3"
          data-name="SVGID 1 3"
          width={135}
          height={135}
          patternTransform="matrix(.95 0 0 .94 531.09 637.53)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 135 135"
        >
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <g id="prefix__image-2">
            <g id="prefix__image-3">
              <use
                id="prefix__image-2-2"
                className="prefix__cls-2"
                xlinkHref="#prefix__image"
              />
            </g>
          </g>
        </pattern>
        <pattern
          id="prefix__SVGID_1_3-3"
          data-name="SVGID 1 3"
          width={135}
          height={135}
          patternTransform="matrix(.95 0 0 .94 531.09 637.53)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 135 135"
        >
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <g id="prefix__image-2-2-2" data-name="image-2">
            <g id="prefix__image-3-2" data-name="image-3">
              <use
                id="prefix__image-2-2-3"
                data-name="image-2-2"
                className="prefix__cls-2"
                xlinkHref="#prefix__image"
              />
            </g>
          </g>
        </pattern>
        <style>
          {
            '.prefix__cls-1,.prefix__cls-40,.prefix__cls-41{fill:none}.prefix__cls-2,.prefix__cls-40,.prefix__cls-41{isolation:isolate}.prefix__cls-6{fill:#333}.prefix__cls-40,.prefix__cls-41{stroke-miterlimit:10;opacity:.2;stroke:gray;stroke-width:.95px}.prefix__cls-41{opacity:.1}'
          }
        </style>
        <image
          id="prefix__image"
          width={135}
          height={135}
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIcAAACHCAYAAAA850oKAAAACXBIWXMAAAsSAAALEgHS3X78AAABVElEQVR4Xu3SMRGAMADAwFL/xmqAHSXUQHMI4H/OmOu51zvgYH4F/Jc5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SBszfASNAbiFZQAAAABJRU5ErkJggg=="
        />
      </defs>
      <g id="prefix__BG">
        <path
          d="M13.23 12.74v383.52H542V12.74zM514.5 233.12V369.27h-217v-14h217v-4.6h-217v-24.75h217v-4.69h-217v-24.75h217v-4.6h-217v-24.75h217v-4.6h-217v-24.75h217v-4.69h-217V218h217zm0-42.1h-217v-14.94h217zm0-19.62h-217v-24.77h217zm0-29.4h-217v-24.81h217zm0-29.5h-217V87.75h217zm0-29.43h-217V58.21h217zm0-29.44h-217V39.74h217z"
          transform="translate(.5 .5)"
          fill="url(#shutters89)"
        />
        <path
          d="M0 0v410h555.2V0zm542 396.75H13.25V13.25H542z"
          transform="translate(.5 .5)"
          fill="url(#shutters89)"
        />
      </g>
      <g id="prefix__Shadows">
        <g opacity={0.15}>
          <path
            className="prefix__cls-6"
            d="M13.66 72.69h1.86v35.73h-1.86zM539.39 72.69h2.48v35.73h-2.48z"
          />
          <path
            className="prefix__cls-6"
            d="M513.42 12.28H296.47v.09h-39v-.09H12.16v384.45h245.38v-.1h39v.1H542V12.28zm-472.83.93h216v26.07h-216zm-28.34 323.6v-35.73h.38v35.73zm27.38 59H13.11v-59H15v-35.73h-1.89V13.21h26.52zm217 0h-216v-26.09h216zm0-117.78h.43v30.91l-.47-.56h.46v30.76l-.47-.57h.46v30.85l-.47-.56h-216v-29.4h217v-.94H40.59v-29.37h217v-.94h-217v-29.35h217v-.94h-217v-29.35h217v-.94h-217v-29.35h105.52v-.18h5v.37h106v29.91l-.47-.56h.42v30.85M40.59 217.53v-26.06h216v26.06zM257.06 70l-.47-.57h1v1h-.47v29.91l-.47-.57h.94v.94h-.47v30l-.47-.65h.94v1h-2.1V131h1.62v29.9l-.47-.56h1v.93h-.47v29.91l-.47-.56H151.07v.38h-5v-.38H40.59v-29.35h217v-.93h-217v-29.45h1.62v.1h215.33v-1H40.59V100.7h217v-.94h-217V70.51h217v-1h-217V40.22h216.52zm19.56 325.84h-19.08V13.12h19.08zm20.8-382.67h216v26.11h-216zm-.86 177.32l-.09 27.94h.09v150.35h-.09v27.1h-19.09V13.12h19.09v27.1h.09zm216.86 205.3h-216v-26.07h216zm.48-158h-.48v24.75h.48v4.69h-.48V292h.48v4.68h-.48v24.57h.48v4.69h-.48v24.75h.48v4.69h-.48v13.51h-216.1v-13.52h-.38v-4.69h.38v-24.75h-.38v-4.69h.38v-24.75h-.38v-4.69h.38V267h-.38v-4.68h.38v-24.53h-.38v-4.69h.38v-14.63h216.1v14.63h.48zm-216.48-20.26v-26.06h216v26.06zM513.9 58.22h-.48v24.85h.48v4.69h-.48v24.75h.48v4.69h-.48V142h.48v4.68h-.48v24.72h.48v4.69h-.48v14.44h-216.1v-14.44h-.38v-4.69h.38v-24.76h-.38V142h.38v-24.8h-.38v-4.69h.38V87.76h-.38v-4.69h.38V58.22h-.38v-4.69h.38V40.22h216.1v13.41h.48zm27.47 49.7h-.47v193.16h.47v35.73h-.47v59h-26.53V13.21h26.53v59h.47z"
            transform="translate(.5 .5)"
          />
          <path
            className="prefix__cls-6"
            d="M539.39 301.58h2.48v35.73h-2.48z"
          />
        </g>
        <path
          fill="url(#prefix__linear-gradient)"
          d="M42.71 40.72h-1.62v29.82l1.62-29.82z"
        />
        <path
          fill="url(#prefix__linear-gradient-2)"
          d="M255.94 40.72h1.62v29.82l-1.62-29.82z"
        />
        <path
          fill="url(#prefix__linear-gradient-3)"
          d="M42.71 71h-1.62v29.92L42.71 71z"
        />
        <path
          fill="url(#prefix__linear-gradient-4)"
          d="M255.94 71h1.62v29.92L255.94 71z"
        />
        <path
          fill="url(#prefix__linear-gradient-5)"
          d="M42.71 101.2h-1.62v29.91l1.62-29.91z"
        />
        <path
          fill="url(#prefix__linear-gradient-6)"
          d="M255.94 101.2h1.62v29.91l-1.62-29.91z"
        />
        <path
          fill="url(#prefix__linear-gradient-7)"
          d="M42.71 131.39h-1.62v29.91l1.62-29.91z"
        />
        <path
          fill="url(#prefix__linear-gradient-8)"
          d="M255.94 131.39h1.62v29.91l-1.62-29.91z"
        />
        <path
          fill="url(#prefix__linear-gradient-9)"
          d="M42.71 161.59h-1.62v29.91l1.62-29.91z"
        />
        <path
          fill="url(#prefix__linear-gradient-10)"
          d="M255.94 161.59h1.62v29.91l-1.62-29.91z"
        />
        <path
          fill="url(#prefix__linear-gradient-11)"
          d="M42.71 218.97h-1.62v29.82l1.62-29.82z"
        />
        <path
          fill="url(#prefix__linear-gradient-12)"
          d="M255.94 218.97h1.62v29.82l-1.62-29.82z"
        />
        <path
          fill="url(#prefix__linear-gradient-13)"
          d="M42.71 249.16h-1.62v29.92l1.62-29.92z"
        />
        <path
          fill="url(#prefix__linear-gradient-14)"
          d="M255.94 249.16h1.62v29.92l-1.62-29.92z"
        />
        <path
          fill="url(#prefix__linear-gradient-15)"
          d="M42.71 279.45h-1.62v29.82l1.62-29.82z"
        />
        <path
          fill="url(#prefix__linear-gradient-16)"
          d="M255.94 279.45h1.62v29.82l-1.62-29.82z"
        />
        <path
          fill="url(#prefix__linear-gradient-17)"
          d="M42.71 309.64h-1.62v29.92l1.62-29.92z"
        />
        <path
          fill="url(#prefix__linear-gradient-18)"
          d="M255.94 309.64h1.62v29.92l-1.62-29.92z"
        />
        <path
          fill="url(#prefix__linear-gradient-19)"
          d="M42.71 339.93h-1.62v29.82l1.62-29.82z"
        />
        <path
          fill="url(#prefix__linear-gradient-20)"
          d="M255.94 339.93h1.62v29.82l-1.62-29.82z"
        />
        <path
          fill="url(#prefix__linear-gradient-21)"
          d="M297.44 54.13H514.4v4.69H297.44z"
        />
        <path
          fill="url(#prefix__linear-gradient-22)"
          d="M297.44 83.66H514.4v4.69H297.44z"
        />
        <path
          fill="url(#prefix__linear-gradient-23)"
          d="M297.44 113.11H514.4v4.69H297.44z"
        />
        <path
          fill="url(#prefix__linear-gradient-24)"
          d="M297.44 142.46H514.4v4.69H297.44z"
        />
        <path
          fill="url(#prefix__linear-gradient-25)"
          d="M297.44 171.9H514.4v4.69H297.44z"
        />
        <path
          fill="url(#prefix__linear-gradient-26)"
          d="M297.44 233.6H514.4v4.69H297.44z"
        />
        <path
          fill="url(#prefix__linear-gradient-27)"
          d="M297.44 263.04H514.4v4.69H297.44z"
        />
        <path
          fill="url(#prefix__linear-gradient-28)"
          d="M297.44 292.39H514.4v4.69H297.44z"
        />
        <path
          fill="url(#prefix__linear-gradient-29)"
          d="M297.44 321.74H514.4v4.69H297.44z"
        />
        <path
          fill="url(#prefix__linear-gradient-30)"
          d="M297.44 351.18H514.4v4.69H297.44z"
        />
        <path
          style={{
            isolation: 'isolate',
          }}
          opacity={0.2}
          strokeMiterlimit={10}
          stroke="#4d4d4d"
          fill="none"
          d="M.5.5h555.2v410H.5z"
        />
        <path
          d="M554.2 1v408H1V1h553.2M12.25 397.75H543V12.25H12.25v385.5M555.2 0H0v410h555.2zM13.25 396.75V13.25H542v383.5z"
          transform="translate(.5 .5)"
          fill="#4d4d4d"
          opacity={0.2}
        />
        <path
          className="prefix__cls-40"
          d="M542.48 13.74l12.25-12.25M13.73 397.26L1.48 409.51M542.48 397.26l12.25 12.25"
        />
        <path
          className="prefix__cls-41"
          d="M3.87 3.88h547.96M11.46 10.69h533.86M3.87 407.07h547.96M11.46 400.26h533.86M3.71 4.37v403.28M10.52 10.69v389.78M552.56 4.37v403.28M545.75 10.69v389.78"
        />
        <path className="prefix__cls-40" d="M13.21 13.11L1.5 1.5" />
      </g>
    </svg>
  );
};
